import React, { useState } from "react";
import CircleRightTop from "../images/EllipseTeamTopLeft.png";
import CircleLeftBottom from "../images/roundedCommunity2.svg";
import blogImage1 from "../../components/images/blog-1.png";
import blogImage2 from "../../components/images/blog-2.png";
import smallCircle from "../../components/images/smallCircle.png";
import Arrow_up_small from "../../Arrow_up_small.svg";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HardikImg from "../images/hardik.webp";
import { useTranslation } from "react-i18next";

const BlogsMain = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();

  const [filteredData, setFilteredData] = useState([]);
  const [category, setCategory] = useState('');

  const data = [
    {
      title: t("blog_1_title"),
      tag: "casestudy",
      content: t("blog_1_desc"),
      image: blogImage1,
    },
    {
      title: t("blog_2_title"),
      tag: "casestudy",
      content: t("blog_1_desc"),
      image: blogImage2,
    },
    {
      title: t("blog_3_title"),
      tag: "insights",
      content: t("blog_3_desc"),
      image: blogImage1,
    },
    {
      title: t("blog_4_title"),
      tag: "insights",
      content: t("blog_4_desc"),
      image: blogImage2,
    }
  ];


  useState(() => {
    setFilteredData(data);
  }, []);

  const filterData = (category) => {
    if (category === 'all') {
      setFilteredData(data);
      setCategory(category)
      return;
    }
    const filtered = data.filter(item => item.tag === category);
    setFilteredData(filtered);
    setCategory(category)
  }

  return (
    <>
      <div className="blogPart_main">
        <img draggable="false"
          src={CircleRightTop}
          className="back_circle1Blogs"
          alt="back_circle1"
        />
        <img draggable="false"
          src={CircleLeftBottom}
          className="back_circle2Blogs"
          alt="back_circle2"
        />
        <div className="container mx-auto px-2 pb-5 md:pb-0 xl:max-w-[1000px] 3xl:max-w-[1400px]">
          <div className="pt-[120px] sm:pt-[110px] lg:pt-[130px]">
            {/* <div className="pb-5 flex justify-center">
              <button className="px-4 py-2 text-[#3359D3] border border-opacity-40 border-[#3359D3] rounded-[38px]">
                Blogs
              </button>
            </div> */}
            <h1 className="capitalize text-center text-[#000] text-[24px] sm:text-[30px] lg:text-[40px] 3xl:text-[70px] font-[700] leading-[30px]  sm:leading-[40px] md:leading-[60px]  3xl:leading-[80px]">
              {t("our_resources")}
            </h1>
            <h1 className="sora text-center text-[18px] font-[400] leading-[26px] text-[#444] mt-1 sm:mt-4 md:mt-0 lg:mt-3">
              {t("our_resources_subtitle")}
            </h1>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-2 pb-5 md:pb-0 xl:max-w-[1000px] 3xl:max-w-[1400px]">
        <div className="w-full flex flex-col lg:flex-row pt-[30px] sm:pt-[60px]">
          <div className={`w-[100%]  z-[1] relative lg:w-[75%] grid grid-cols-1  ${filteredData.length !== 0 ? "sm:grid-cols-2" : "sm:grid-cols-1"} gap-3`}>
            {filteredData.length > 0 ? (
              filteredData.map((cards) => {
                return (
                  <div key={cards} className="w-full xl:w-full">
                    <img draggable="false" className="w-full rounded-xl" src={cards.image} alt="blogCards" />
                    <div className="h-full">
                      <div className="flex flex-col justify-between">
                        <div className="">
                          <div className="flex pt-2 items-center">
                            <img draggable="false" src={HardikImg} className="h-auto w-[38px] rounded-full" alt="mainImage" />
                            <span className="sora text-[#6A6A6A] font-[400] text-[12px] sm:text-[14px] px-2">
                              {t("by")} Hardik Nimbark
                            </span>
                            <div className="flex items-center">
                              <div className="mr-1">
                                <img draggable="false" src={smallCircle} alt="smallCircle pr-2" />
                              </div>
                              <span className="sora text-[#6A6A6A] font-[400] text-[14px]">
                                May 01,2024
                              </span>
                            </div>
                          </div>
                          <h1 className="sora text-[#000] text-[18px] sm:text-[20px] font-[600] pt-3 pb-3 truncate">
                            {cards.title}
                            <p className="sora text-[14px]">#{cards.tag}</p>
                          </h1>
                          <div className="w-auto overflow-hidden overflow-ellipsis max-h-24"
                            style={{
                              WebkitLineClamp: 4,
                              WebkitBoxOrient: 'vertical',
                              display: "-webkit-box",
                            }}
                          >
                          {cards.content}
                          </div>
                          {/* <p className="sora text-[#6A6A6A] text-[14px]  sm:text-[16px] font-[400] min-h-[95px] truncate">
                            {cards.content}
                          </p> */}
                        </div>

                        <div className="py-3 sm:py-3">
                          <div
                            className="getStartedBtnOuter"
                          // onClick={() =>
                          //   navigate("/contact-us")
                          // }
                          >
                            <Button className="NunitoSans getStartedBtn">
                              {t("read_the_article")}
                              <img draggable="false"
                                src={Arrow_up_small}
                                className="w-[9px] sm:w-[12px] ml-[4px]"
                                alt="Arrow_up_small"
                              />
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                );
              })
            ) : (
              <div>
                <div className="border rounded-xl p-4">
                  <p className="text-center">{t("no_blog_msg")}</p>
                </div>
              </div>
            )}


          </div>
          <div className="w-[100%] lg:w-[25%] mb-5 ml-0 lg:ml-[10px] order-first lg:order-last">
            <div className="relative">
              <input
                type="text"
                className="sora py-[13px] px-4 lg:py-5 border border-[#DCDCDC] rounded-[40px] w-[100%]"
                placeholder={t("search_categories")}
              ></input>
              {/* <img draggable="false"
                className="absolute top-[13px] right-[7px] h-[40px]"
                src={searchIcon}
                alt="searchIcon"
              /> */}
            </div>
            <div className="pt-4">
              <div
                className="border border-[#d9e4f9] py-5 rounded-[30px] "
                style={{
                  backgroundImage: "linear-gradient(304deg, rgb(245 246 253) 8.68%, rgb(245 246 253 / 0%) 93.62%)"
                }}
              >
                <h1 className="sora text-[18px] text-[#000] font-[600]  py-2 px-5">
                  {t("categories")}
                </h1>
                <h1 className={`sora text-[16px] text-[#000] font-[400] border-b border-[#DCDCDC] py-2 sm:py-4 px-5 sm:px-4 hover:bg-[#e6ecff] cursor-pointer ${category === "all" ? "bg-[#e6ecff]" : ""}`} onClick={() => filterData("all")}>
                  {t("all")}
                </h1>
                <h1 className={`sora text-[16px] text-[#000] font-[400] border-b border-[#DCDCDC] py-2 sm:py-4 px-5 sm:px-4 hover:bg-[#e6ecff] cursor-pointer ${category === "casestudy" ? "bg-[#e6ecff]" : ""}`} onClick={() => filterData("casestudy")}>
                  {t("case_study")}
                </h1>
                <h1 className={`sora text-[16px] text-[#000] font-[400] border-b border-[#DCDCDC] py-2 sm:py-4 px-5 sm:px-4 hover:bg-[#e6ecff] cursor-pointer ${category === "news" ? "bg-[#e6ecff]" : ""}`} onClick={() => filterData("news")}>
                  {("news")}
                </h1>
                <h1 className={`sora text-[16px] text-[#000] font-[400] border-b border-[#DCDCDC] py-2 sm:py-4 px-5 sm:px-4 hover:bg-[#e6ecff] cursor-pointer ${category === "insights" ? "bg-[#e6ecff]" : ""}`} onClick={() => filterData("insights")}>
                  {("insights")}
                </h1>
                <h1 className={`sora text-[16px] text-[#000] font-[400] border-b border-[#DCDCDC] py-2 sm:py-4 px-5 sm:px-4 hover:bg-[#e6ecff] cursor-pointer ${category === "events" ? "bg-[#e6ecff]" : ""}`} onClick={() => filterData("events")}>
                  {t("events")}
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className=" border-t-2 ">
          <div className="pt-5 flex justify-between">
            <span className="inter font-[500] text-[14px]">{t("page")} 1 {t("of")} 1</span>
            <div className="flex">
              <div
                href="#"
                className="sora cursor-pointer flex mr-3 items-center justify-center px-3 h-8 text-sm font-medium text-black-500 bg-white border border-gray-300 rounded-[8px] hover:bg-gray-100 "
              >
                {t("previous")}
              </div>

              <div
                href="#"
                className="sora flex cursor-pointer items-center justify-center px-3 h-8 text-sm font-medium text-black-500 bg-white border border-gray-300 rounded-[8px] hover:bg-gray-100"
              >
                {t("next")}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogsMain;
